import { State } from '@seiue/ui'
import styled from 'styled-components'

import { AnyType } from 'packages/types'

import emptySvg from '../utils/empty.svg'

/**
 * 门户管理 应用列表-空应用页
 *
 * @param param - 参数
 * @param param.isForground - 是否为前台
 * @param param.query - 请求参数
 * @returns 组件
 */
export const Empty: React.FC<{
  isForground?: boolean
  query?: AnyType
}> = ({ isForground, query }) => {
  const isSearch = query.labelLike !== undefined

  return (
    <EmptyBox>
      <State.Empty
        image={
          <ImgBox>
            <img src={emptySvg} />
          </ImgBox>
        }
        description={
          <TextBox>
            {isSearch
              ? '暂无搜索结果'
              : isForground
              ? '暂无应用'
              : '暂未添加应用，去添加吧~'}
          </TextBox>
        }
      />
    </EmptyBox>
  )
}

const EmptyBox = styled.div`
  height: 80vh;

  & .ant-empty-image {
    margin-bottom: 0;
  }
`

const ImgBox = styled.div``

const TextBox = styled.span`
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  text-align: center;
  width: 161px;
  height: 22px;
  color: #455766;
`
